/* sp-join.js: /pages/join behaviour (port of the mockup inline script).
   Cart state is read from data attributes Liquid renders on each .chip in the buy box
   (data-variant, data-plan, data-ground, data-bag-src, data-bag-srcset): no hard-coded ids here.
   Links with [data-spj-sub] get the membership cart URL, [data-spj-once] the one-time URL. */
(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function $(id){ return document.getElementById(id); }
  function all(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function pre(el){ var p = el.getAttribute("data-prefix") || el.getAttribute("data-alt-prefix") || ""; return p ? p + " " : ""; }

  /* ---- buy state ---- */
  var chips = all(".spj .chip[data-variant]");
  function cartUrl(chip, sub){
    var u = "/cart/add?id=" + chip.getAttribute("data-variant") + "&quantity=1";
    var plan = chip.getAttribute("data-plan");
    return sub && plan ? u + "&selling_plan=" + plan : u;
  }
  var current = null;
  function render(chip){
    if (!chip) return;
    current = chip;
    var f = chip.getAttribute("data-name");
    chips.forEach(function(c){ c.setAttribute("aria-pressed", c === chip ? "true" : "false"); });
    var fn = $("flavor-name"); if (fn) fn.textContent = f;
    var ground = chip.getAttribute("data-ground");
    var stage = $("gal-stage"); if (stage && ground) stage.style.setProperty("--gal", ground);
    var sw = $("gthumb-sw"); if (sw && ground) sw.style.setProperty("--sw", ground);
    var flag = $("gal-flag"); if (flag) flag.textContent = pre(flag) + f;
    var gi = $("gal-img");
    if (gi){
      var src = chip.getAttribute("data-bag-src"), set = chip.getAttribute("data-bag-srcset");
      if (chips[0]) gi.setAttribute("data-fallback", chips[0].getAttribute("data-bag-src"));
      if (src && gi.getAttribute("src") !== src){
        gi.style.display = "";
        if (set) gi.setAttribute("srcset", set); else gi.removeAttribute("srcset");
        gi.setAttribute("src", src);
      }
      gi.alt = pre(gi) + f;
    }
    var sub = cartUrl(chip, true), once = cartUrl(chip, false);
    all("[data-spj-sub]").forEach(function(a){ a.href = sub; });
    all("[data-spj-once]").forEach(function(a){ a.href = once; });
    var sp = $("sbar-plan"); if (sp) sp.textContent = pre(sp) + f;
  }
  chips.forEach(function(c){ c.addEventListener("click", function(){ render(c); showSlide(0); }); });

  /* ---- gallery slides ---- */
  var thumbs = all(".spj .gthumb");
  var slides = all(".spj .gslide");
  function showSlide(n){
    thumbs.forEach(function(t){ t.setAttribute("aria-selected", +t.getAttribute("data-slide") === n ? "true" : "false"); });
    slides.forEach(function(s, i){ s.classList.toggle("on", i === n); });
  }
  thumbs.forEach(function(t){ t.addEventListener("click", function(){ showSlide(+t.getAttribute("data-slide")); }); });
  /* ?flavor=<Flavor Name> (homepage CTAs): preselect that chip, case-insensitive; unknown values ignored */
  function urlFlavor(){
    var m = /[?&]flavor=([^&#]*)/i.exec(location.search); if (!m) return "";
    try { return decodeURIComponent(m[1].replace(/\+/g, " ")).trim().toLowerCase(); } catch (e){ return ""; }
  }
  var pressed = chips.filter(function(c){ return c.getAttribute("aria-pressed") === "true"; })[0] || chips[0];
  var want = urlFlavor();
  if (want) pressed = chips.filter(function(c){ return (c.getAttribute("data-name") || "").toLowerCase() === want; })[0] || pressed;
  render(pressed);

  /* ---- header menu (phones / narrow): toggles the anchor list; closes on link tap and Esc ---- */
  var mb = $("menu-btn"), mnav = $("mnav");
  function setMenu(open){ if (!mb || !mnav) return; mb.setAttribute("aria-expanded", open ? "true" : "false"); mnav.classList.toggle("open", open); }
  if (mb && mnav){
    mb.addEventListener("click", function(){ setMenu(mb.getAttribute("aria-expanded") !== "true"); });
    Array.prototype.forEach.call(mnav.querySelectorAll("a"), function(a){ a.addEventListener("click", function(){ setMenu(false); }); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape" && mnav.classList.contains("open")){ setMenu(false); mb.focus(); } });
  }

  /* ---- accordions ---- */
  all(".spj .acc-btn").forEach(function(b){
    b.addEventListener("click", function(){
      var open = b.getAttribute("aria-expanded") === "true";
      b.setAttribute("aria-expanded", open ? "false" : "true");
      var p = $(b.getAttribute("aria-controls")); if (p) p.classList.toggle("open", !open);
    });
  });

  /* ---- announcement rotator ---- */
  var ann = $("ann");
  if (ann){
    var annP = ann.querySelectorAll("p");
    if (annP.length > 1) setInterval(function(){
      var alt = ann.classList.toggle("alt");
      annP[0].setAttribute("aria-hidden", alt ? "true" : "false");
      annP[1].setAttribute("aria-hidden", alt ? "false" : "true");
    }, 4000);
  }

  /* ---- scroll-driven: header, pinned numerals, sticky bar, reveals ----
     Reveal is deliberately NOT IntersectionObserver (see mockup note): a rAF-throttled geometry
     check means anything that has entered the viewport, or been scrolled past, is revealed. */
  var hdr = $("hdr"), sbar = $("sbar"), buy = $("buy");
  var ftr = document.querySelector(".spj .ftr");
  var ctas = all(".spj a.btn, .spj .tlink, .spj .acc-panel a").filter(function(a){ return (!sbar || !sbar.contains(a)) && !(mnav && mnav.contains(a)); });
  function padForBar(){ if (!sbar) return; var h = sbar.offsetHeight; if (h) document.body.style.setProperty("--sbar-h", h + "px"); }
  padForBar(); window.addEventListener("resize", padForBar);
  var nums = $("nums"), numsLi = all("#nums-list li"), numsBag = $("nums-bag");
  var items = all(".spj .rv");
  if (reduce){ items.forEach(function(el){ el.classList.add("is-in"); }); items = []; numsLi.forEach(function(li){ li.classList.add("lit"); }); }
  var ticking = false;
  function pass(){
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (hdr) hdr.classList.toggle("is-scrolled", y > 80);

    if (sbar){
      var inBuy = false;
      if (buy){ var br = buy.getBoundingClientRect(); inBuy = br.top < vh * 0.6 && br.bottom > vh * 0.4; }
      var zone = vh - (sbar.offsetHeight || 110) - 8, covers = false;
      for (var c = 0; c < ctas.length && !covers; c++){
        var cr = ctas[c].getBoundingClientRect();
        if (cr.height && cr.bottom > zone && cr.top < vh) covers = true;
      }
      var ftrIn = ftr && ftr.getBoundingClientRect().top < vh;
      /* 2026-10-12 (optimizer F1): the bar used to stay hidden for the whole buy box, so between the gallery and the button
         nothing to buy with was on screen. Now, inside the buy box, it hides only while the main button itself is on screen. */
      var bcta = $("buy-cta"), ctaOn = false;
      if (bcta){ var tr = bcta.getBoundingClientRect(); ctaOn = tr.height > 0 && tr.bottom > 0 && tr.top < vh; }
      sbar.classList.toggle("show", y > 500 && !(inBuy && ctaOn) && !covers && !ftrIn);
    }

    if (!reduce && nums){
      var nr = nums.getBoundingClientRect();
      var span = Math.max(1, nr.height - vh);
      var p = Math.min(1, Math.max(0, -nr.top / span));
      numsLi.forEach(function(li, i){ li.classList.toggle("lit", p >= i * 0.22 + 0.04 || nr.bottom < vh); });
      if (numsBag) numsBag.style.setProperty("--rise", (60 - 60 * Math.min(1, p * 1.4)).toFixed(1) + "%");
    }

    for (var i = items.length - 1; i >= 0; i--){
      var r = items[i].getBoundingClientRect();
      if (r.top < vh * 0.92){ items[i].classList.add("is-in"); items.splice(i, 1); }
    }
  }
  function onScroll(){ if (!ticking){ ticking = true; window.requestAnimationFrame(pass); } }
  window.addEventListener("scroll", onScroll, { passive:true });
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", onScroll);
  pass();
  /* theme editor: re-run reveal after a section re-renders */
  document.addEventListener("shopify:section:load", function(){ all(".spj .rv").forEach(function(el){ el.classList.add("is-in"); }); });
})();

/* ---- member gifts pop-up (DECISIONS-F F22): opens on arrival, once per session, never under ?nopop=1.
   EMAIL STEP (2026-10-04, same as sp-home-giftpop): when the section renders .gpop-form the cards stay locked until a valid
   email is accepted by the Klaviyo client subscriptions API; with no form (setting off) it behaves as before.
   Shares the device-wide sp_gifts state with the homepage pop-up (done = never again; dismissed = 7 days).
   Nine cards, pick three. Every path shows the same three gifts in a fixed order (picks 1, 2, 3 = gifts 1, 2, 3);
   the other six stay face down (dimmed, inert). Focus-trapped; Esc / X / "Look around first" close;
   "Let me in" closes and scrolls to #buy. Page scroll is locked only while it is open. ---- */
(function(){
  "use strict";
  var pop = document.querySelector("[data-spj-giftpop]");
  if (!pop) return;
  var KEY = "spj-giftpop-seen";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var card = pop.querySelector(".gpop-card");
  var cards = Array.prototype.slice.call(pop.querySelectorAll(".gc"));
  var gifts = Array.prototype.slice.call(pop.querySelectorAll("template[data-gift]"));
  var status = pop.querySelector(".gifts-status");
  var sum = pop.querySelector(".gsum");
  var sumH = sum && sum.querySelector("h3");
  var show = pop.querySelector(".gifts-show");
  var form = pop.querySelector(".gpop-form"), input = form && form.querySelector("input[type=email]");
  var submit = form && form.querySelector("button[type=submit]"), msg = pop.querySelector(".gpop-msg"), okMsg = pop.querySelector(".gpop-ok");
  var PICKS = 3, turned = 0, picks = 0, done = false, isOpen = false, lastFocus = null, unlocked = !form, sending = false, sentEmail = "";
  var root = document.documentElement;
  /* ---- shared 9-card state (BOTH pop-ups: sp-join-giftpop + sp-home-giftpop; keep the two copies identical) ----
     localStorage "sp_gifts" = {state:"done"|"dismissed", picks:[card indexes], ts} + a mirror cookie "sp_gifts"
     (path=/, 180 days, SameSite=Lax) for Safari ITP / private mode. done = never auto-open again on this device;
     dismissed = no auto-open for 7 days. Everything is wrapped: with storage blocked the page still works. */
  var GKEY = "sp_gifts", GDAYS = 7;
  function gParse(raw){ try { var o = JSON.parse(raw); return o && (o.state === "done" || o.state === "dismissed") ? o : null; } catch (err){ return null; } }
  function gRead(){
    var a = null, b = null;
    try { a = gParse(localStorage.getItem(GKEY)); } catch (err){}
    try { var m = document.cookie.match(/(?:^|;\s*)sp_gifts=([^;]*)/); if (m) b = gParse(decodeURIComponent(m[1])); } catch (err){}
    if (!a || !b) return a || b;
    if (a.state === "done") return a;
    if (b.state === "done") return b;
    return (+b.ts || 0) > (+a.ts || 0) ? b : a;
  }
  function gWrite(state, pickList){
    var cur = gRead();
    if (cur && cur.state === "done" && state !== "done") return;
    var v = JSON.stringify({ state: state, picks: pickList || [], ts: Date.now() });
    try { localStorage.setItem(GKEY, v); } catch (err){}
    try { document.cookie = GKEY + "=" + encodeURIComponent(v) + "; path=/; max-age=" + (180 * 86400) + "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : ""); } catch (err){}
  }
  function gBlocked(){
    var o = gRead(); if (!o) return false;
    if (o.state === "done") return true;
    return Date.now() - (+o.ts || 0) < GDAYS * 86400000;
  }
  function gPicks(){ var out = []; cards.forEach(function(c, i){ if (c.getAttribute("aria-pressed") === "true") out.push(i); }); return out; }
  /* quiet outcome on the page once the cards are done: the "Your three gifts are in" line by the offer */
  function showIn(){ Array.prototype.forEach.call(document.querySelectorAll("[data-spj-gifts-in]"), function(el){ el.hidden = false; }); }

  function setLocked(on){
    unlocked = !on;
    pop.classList.toggle("is-locked", on); pop.classList.toggle("is-unlocked", !on);
    cards.forEach(function(c){ if (on) c.setAttribute("aria-disabled", "true"); else c.removeAttribute("aria-disabled"); });
  }
  function turn(c, delay){
    if (c.getAttribute("aria-pressed") === "true") return null;
    var g = gifts[turned % gifts.length]; turned++;
    var front = c.querySelector(".gc-front");
    while (front.firstChild) front.removeChild(front.firstChild);
    front.appendChild(g.content.cloneNode(true));
    var gf = g.style.getPropertyValue("--gf"); if (gf) front.style.setProperty("--gf", gf);
    c.setAttribute("aria-pressed", "true");
    c.setAttribute("aria-label", g.getAttribute("data-label"));
    if (delay && !reduce) setTimeout(function(){ c.classList.add("is-flipped"); }, delay);
    else c.classList.add("is-flipped");
    return g;
  }
  function finish(start, focusSummary){
    if (done) return;
    done = true;
    gWrite("done", gPicks()); showIn(); kEvent("SP Gifts Picked Three");
    /* the other cards stay face down: dimmed and inert */
    cards.forEach(function(c){
      if (c.getAttribute("aria-pressed") !== "true"){ c.disabled = true; c.classList.add("is-rest"); c.setAttribute("aria-hidden", "true"); }
    });
    pop.classList.add("is-done");
    if (sum) sum.classList.add("is-on");
    if (status) status.textContent = pop.getAttribute("data-done") || "";
    var wait = reduce ? 0 : start + 500;
    setTimeout(function(){
      if (!isOpen || !sum) return;
      if (focusSummary && sumH) sumH.focus();
      /* phones: the summary sits under the cards, bring it into view inside the pop-up */
      var cr = card.getBoundingClientRect(), sr = sum.getBoundingClientRect();
      if (sr.bottom > cr.bottom || sr.top < cr.top) card.scrollTop += sr.top - cr.top - 16;
    }, wait);
  }
  /* LOCKED-CARD NUDGE (2026-10-09, site optimizer): a tap on a face-down card before the email (or phone) step only re-focused
     a field that already had focus, so nothing visibly happened (Clarity, 7 days to 10/9, mobile /pages/join: 204 taps on the
     face-down cards vs 48 on the email field; six recordings tap a locked card, get no answer and leave). Now the tap answers: the field row shakes with a lime
     ring, a one-line hint appears under it (section settings "Locked card hint"), the form is brought into view inside the
     pop-up and the field is re-focused inside the tap so phones raise the keyboard. Typing or sending clears the hint. */
  var nudgeT = 0;
  function nudge(){
    var phone = pop.classList.contains("is-phone");
    var f = phone ? pform : form, fi = phone ? pinput : input, m = phone ? pmsg : msg;
    if (!f || !fi) return;
    var hint = pop.getAttribute(phone ? "data-hint-phone" : "data-hint") || "";
    if (m && hint){ m.textContent = hint; f.classList.add("has-hint"); }
    f.classList.remove("is-nudge"); void f.offsetWidth; f.classList.add("is-nudge");
    clearTimeout(nudgeT); nudgeT = setTimeout(function(){ f.classList.remove("is-nudge"); }, 700);
    var cr = card.getBoundingClientRect(), fr = f.getBoundingClientRect();
    if (fr.top < cr.top + 8) card.scrollTop += fr.top - cr.top - 16;
    try { if (document.activeElement === fi) fi.blur(); fi.focus({ preventScroll: true }); } catch (err){ try { fi.focus(); } catch (err2){} }
  }
  function clearHint(f, m){
    if (!f || !f.classList.contains("has-hint")) return;
    f.classList.remove("has-hint");
    if (m && (m.textContent === pop.getAttribute("data-hint") || m.textContent === pop.getAttribute("data-hint-phone"))) m.textContent = "";
  }
  if (form){ input.addEventListener("input", function(){ clearHint(form, msg); }); form.addEventListener("submit", function(){ clearHint(form, msg); }, true); }
  cards.forEach(function(c){
    c.addEventListener("click", function(){
      if (!unlocked){ nudge(); return; }
      if (done) return;
      var g = turn(c, 0);
      if (!g) return;
      picks++;
      if (status) status.textContent = g.getAttribute("data-label");
      if (picks >= PICKS) finish(reduce ? 0 : 450, document.activeElement === c);
    });
  });
  /* "Show me" turns over exactly as many face-down cards as picks are left (three at most), never all nine */
  if (show) show.addEventListener("click", function(){
    if (!unlocked || done) return;
    var left = cards.filter(function(c){ return c.getAttribute("aria-pressed") !== "true"; });
    var k = 0;
    while (picks < PICKS && left.length){
      var c = left.splice(Math.floor(Math.random() * left.length), 1)[0];
      if (turn(c, k * 120)) { picks++; k++; }
    }
    finish(reduce ? 0 : k * 120 + 450, true);
  });

  /* email -> Klaviyo client subscriptions API (same list as the homepage pop-up). The ad's utm tags ride along as profile
     properties so a signup can be traced to the ad that sent it. */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KHEAD = { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": "2025-04-15" };
  function utm(){
    var out = { sp_signup_page: "join" };
    try {
      var q = new URLSearchParams(location.search);
      ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(function(k){ var v = q.get(k); if (v) out["sp_" + k] = v.slice(0, 120); });
    } catch (err){}
    return out;
  }
  /* Klaviyo event for the person who just gave an email (counts "picked three" per day in Klaviyo); silent on failure */
  function kEvent(name){
    if (!sentEmail) return;
    try {
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(pop.getAttribute("data-company")), {
        method: "POST", headers: KHEAD, keepalive: true,
        body: JSON.stringify({ data: { type: "event", attributes: { properties: utm(),
          metric: { data: { type: "metric", attributes: { name: name } } },
          profile: { data: { type: "profile", attributes: { email: sentEmail } } } } } })
      }).catch(function(){});
    } catch (err){}
  }
  if (form) form.addEventListener("submit", function(e){
    e.preventDefault();
    if (sending) return;
    var em = (input.value || "").trim();
    if (!EMAIL.test(em)){ msg.textContent = pop.getAttribute("data-bad") || ""; input.focus(); return; }
    msg.textContent = ""; sending = true; submit.disabled = true;
    var body = { data: { type: "subscription", attributes: {
        custom_source: pop.getAttribute("data-source") || "SP join 9-card pop-up",
        profile: { data: { type: "profile", attributes: { email: em, properties: utm(), subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } },
      relationships: { list: { data: { type: "list", id: pop.getAttribute("data-list") } } } } };
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(pop.getAttribute("data-company")), {
      method: "POST", headers: KHEAD, body: JSON.stringify(body)
    }).then(function(r){
      if (!r.ok) throw new Error("klaviyo " + r.status);
      sending = false; sentEmail = em; afterEmail(em);
    }).catch(function(){
      sending = false; submit.disabled = false;
      msg.textContent = pop.getAttribute("data-err") || "";
    });
  });

  /* phone step (2026-10-05, optional for the visitor): shown once the email is accepted; "Claim my gift" saves the number to
     the same Klaviyo profile + list with SMS marketing consent, the skip link saves nothing; either one unlocks the cards. */
  var pform = pop.querySelector(".gpop-phone"), pinput = pform && pform.querySelector("input[type=tel]");
  var psubmit = pform && pform.querySelector("button[type=submit]"), pmsg = pform && pform.querySelector(".gpop-pmsg");
  var pskip = pform && pform.querySelector("[data-gpop-nophone]"), psending = false, gotEmail = "";
  function afterEmail(em){
    gotEmail = em;
    if (!pform){ setLocked(false); if (okMsg) okMsg.focus(); return; }
    pop.classList.add("is-phone");
    setTimeout(function(){ try { pinput.focus({ preventScroll: true }); } catch (err){ pinput.focus(); } }, 30);
  }
  function afterPhone(cls){
    pop.classList.add(cls); pop.classList.remove("is-phone"); setLocked(false);
    if (okMsg) okMsg.focus();
  }
  if (pform){
    pinput.addEventListener("input", function(){ clearHint(pform, pmsg); }); pform.addEventListener("submit", function(){ clearHint(pform, pmsg); }, true);
    pskip.addEventListener("click", function(){ afterPhone("is-nophone"); });
    pform.addEventListener("submit", function(e){
      e.preventDefault();
      if (psending) return;
      var d = (pinput.value || "").replace(/\D/g, "");
      if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1);
      if (d.length !== 10 || d.charAt(0) < "2" || d.charAt(3) < "2"){ pmsg.textContent = pform.getAttribute("data-bad") || ""; pinput.focus(); return; }
      pmsg.textContent = ""; psending = true; psubmit.disabled = true;
      var body = { data: { type: "subscription", attributes: {
          custom_source: (pop.getAttribute("data-source") || "SP 9-card pop-up") + " (phone)",
          profile: { data: { type: "profile", attributes: { email: gotEmail, phone_number: "+1" + d,
            properties: { sp_phone_from: "9-card pop-up" }, subscriptions: { sms: { marketing: { consent: "SUBSCRIBED" } } } } } } },
        relationships: { list: { data: { type: "list", id: pop.getAttribute("data-list") } } } } };
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(pop.getAttribute("data-company")), {
        method: "POST", headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": "2025-04-15" },
        body: JSON.stringify(body)
      }).then(function(r){
        psending = false;
        if (!r.ok) throw new Error("klaviyo " + r.status);
        afterPhone("is-phoned");
      }).catch(function(){
        psending = false; psubmit.disabled = false;
        pmsg.textContent = pop.getAttribute("data-err") || "";
      });
    });
  }

  function focusables(){
    return Array.prototype.slice.call(card.querySelectorAll("button, a[href], input, [tabindex]:not([tabindex='-1'])"))
      .filter(function(el){ return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== "hidden"; });
  }
  function onKey(e){
    if (!isOpen) return;
    if (e.key === "Escape" || e.key === "Esc"){ e.preventDefault(); close(); return; }
    if (e.key !== "Tab") return;
    var f = focusables(); if (!f.length){ e.preventDefault(); card.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !card.contains(a))){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !card.contains(a))){ e.preventDefault(); first.focus(); }
  }
  function open(){
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    try { sessionStorage.setItem(KEY, "1"); } catch (err){}
    root.classList.add("spj-gpop-open");
    pop.classList.add("is-open");
    document.addEventListener("keydown", onKey, true);
    setTimeout(function(){ var t = unlocked ? (cards[0] || card) : (input || card); try { t.focus({ preventScroll: true }); } catch (err){ t.focus(); } }, 30);
  }
  function close(){
    if (!isOpen) return;
    isOpen = false;
    if (!done) gWrite("dismissed", gPicks());
    pop.classList.remove("is-open");
    root.classList.remove("spj-gpop-open");
    document.removeEventListener("keydown", onKey, true);
    if (lastFocus && lastFocus.focus && lastFocus !== document.body) { try { lastFocus.focus(); } catch (err){} }
  }
  Array.prototype.forEach.call(pop.querySelectorAll("[data-gpop-close]"), function(b){ b.addEventListener("click", close); });
  pop.addEventListener("click", function(e){ if (e.target === pop) close(); });
  Array.prototype.forEach.call(pop.querySelectorAll("[data-gpop-join]"), function(a){
    a.addEventListener("click", function(e){
      e.preventDefault();
      close();
      var t = document.getElementById("buy");
      if (t) t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    });
  });

  /* auto-open: on arrival, once per session; ?nopop=1 skips it (ads QA / testing) */
  var skip = /[?&]nopop=1(&|$)/.test(location.search);
  var seen = false;
  try { seen = sessionStorage.getItem(KEY) === "1"; } catch (err){}
  if (pop.getAttribute("data-enabled") === "false") skip = true;
  var st = gRead();
  if (st && st.state === "done") showIn();
  if (!skip && !seen && !gBlocked()) open();
  window.spjGiftpop = { open: open, close: close };
})();

/* ---- FAQ background candy: parallax translateY + slow turn, driven by the section's pass through the viewport.
   rAF + transform only; runs only while the section is on screen (IntersectionObserver); static under reduced motion. ---- */
(function(){
  "use strict";
  var box = document.querySelector("[data-spj-faq-candy]");
  if (!box) return;
  var img = box.querySelector("img"), sec = box.parentNode;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!img || reduce || !window.requestAnimationFrame) return;
  var SHIFT = parseFloat(box.getAttribute("data-shift")) || 80, TURN = parseFloat(box.getAttribute("data-turn")) || 12;
  var active = false, ticking = false;
  function draw(){
    ticking = false;
    var r = sec.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    var p = (vh - r.top) / (vh + r.height); if (p < 0) p = 0; else if (p > 1) p = 1;
    var k = window.innerWidth <= 640 ? 0.5 : 1;
    img.style.transform = "translate3d(0," + ((p * 2 - 1) * SHIFT * k).toFixed(1) + "px,0) rotate(" + ((p * 2 - 1) * TURN).toFixed(2) + "deg)";
  }
  function onScroll(){ if (active && !ticking){ ticking = true; window.requestAnimationFrame(draw); } }
  function setActive(on){
    if (on === active) return;
    active = on;
    if (on){ window.addEventListener("scroll", onScroll, { passive: true }); window.addEventListener("resize", onScroll); onScroll(); }
    else { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); }
  }
  if ("IntersectionObserver" in window){
    new IntersectionObserver(function(es){ setActive(es[es.length - 1].isIntersecting); }, { rootMargin: "100px 0px" }).observe(sec);
  } else setActive(true);
})();

/* ---- cart adds (Phase 13, QA F2): every /cart/add link on this page is sent as ONE fetch POST to /cart/add.js instead of
   a GET navigation. Shopify's own pixel pipeline (Meta / Google / app pixels) only publishes product_added_to_cart for
   ajax adds, so the GET link sent NO AddToCart for the 30-Pack and the only one Meta saw was the $5 protection line added
   later on /cart. Now: exactly one AddToCart per add (content_ids = variant id, value = line price, with Shopify's
   dedupe event id: the same convention as the PDPs). Nothing is fired by hand here, so nothing can double.
   Guards: one request at a time; a variant + plan that is already in the cart is not added again (drawer opens instead).
   Any failure falls back to the original link. sp-cart.js (not edited) opens the drawer and keeps the protection line. ---- */
(function(){
  "use strict";
  var busy = false;
  function parse(href){
    var m = /\/cart\/add\?([^#]*)/.exec(href || ""); if (!m) return null;
    var o = {}; m[1].split("&").forEach(function(kv){ var p = kv.split("="); o[decodeURIComponent(p[0])] = decodeURIComponent(p[1] || ""); });
    if (!/^\d+$/.test(o.id || "")) return null;
    return { id: Number(o.id), quantity: Math.max(1, parseInt(o.quantity, 10) || 1), plan: /^\d+$/.test(o.selling_plan || "") ? Number(o.selling_plan) : null };
  }
  function show(){ if (!(window.SPCart && window.SPCart.open && window.SPCart.open() !== false)) window.location.href = "/cart"; }
  document.addEventListener("click", function(e){
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('.spj a[href*="/cart/add?"]') : null;
    if (!a || !window.fetch) return;
    var want = parse(a.getAttribute("href")); if (!want) return;
    e.preventDefault();
    if (busy) return;
    busy = true; a.setAttribute("aria-busy", "true");
    var href = a.href;
    function done(){ busy = false; a.removeAttribute("aria-busy"); }
    fetch("/cart.js", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function(r){ return r.ok ? r.json() : { items: [] }; })
      .then(function(cart){
        var has = (cart.items || []).some(function(i){
          var p = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? Number(i.selling_plan_allocation.selling_plan.id) : null;
          return Number(i.variant_id) === want.id && p === want.plan;
        });
        if (has){ done(); show(); return null; }
        var item = { id: want.id, quantity: want.quantity }; if (want.plan) item.selling_plan = want.plan;
        return fetch("/cart/add.js", { method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [item] }) })
          .then(function(r){ if (!r.ok) throw new Error("add " + r.status); return r.json(); })
          .then(function(){ done(); if (!(window.SPCart && window.SPCart.open)) window.location.href = "/cart"; });
      })
      .catch(function(){ done(); window.location.href = href; });
  });
})();
